import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  max-width: 900px;
  margin: 4rem auto;
  padding: 0 1.5rem;
  color: #333;
  line-height: 1.6;
  font-family: 'Inter', sans-serif;

  h1 {
    font-size: 2rem;
    margin-bottom: 1.5rem;
    color: #111;
  }

  h3 {
    font-size: 1.2rem;
    margin-top: 1.8rem;
    margin-bottom: 0.5rem;
    color: #222;
  }

  p, li {
    color: #555;
    font-size: 0.95rem;
  }

  ul {
    padding-left: 1.2rem;
  }
`;

const PoliticaPrivacidad = () => {
  return (
    <PageContainer>
      <h1>Política de Privacidad — Danyweb</h1>
      
      <p>
        En <strong>Danyweb</strong> nos tomamos muy en serio la privacidad de nuestros usuarios y clientes. Esta política describe cómo recopilamos, utilizamos y protegemos tu información personal al interactuar con nuestro sitio web.
      </p>

      <h3>1. Información que recopilamos</h3>
      <p>
        Recopilamos únicamente los datos necesarios que nos proporcionas de forma voluntaria al ponerte en contacto con nosotros (a través de formularios, correo electrónico o WhatsApp):
      </p>
      <ul>
        <li>Nombre y apellido.</li>
        <li>Dirección de correo electrónico.</li>
        <li>Número de teléfono.</li>
        <li>Detalles o requerimientos sobre tu proyecto web.</li>
      </ul>

      <h3>2. Uso de la información</h3>
      <p>La información recopilada se utiliza exclusivamente para:</p>
      <ul>
        <li>Responder a tus consultas o solicitudes de presupuesto.</li>
        <li>Gestionar la relación comercial y la prestación de los servicios contratados.</li>
        <li>Enviar comunicaciones relevantes relacionadas con tu proyecto.</li>
      </ul>

      <h3>3. Protección de datos</h3>
      <p>
        No vendemos, alquilamos ni compartimos tus datos personales con terceros con fines comerciales o publicitarios. Implementamos medidas de seguridad para garantizar que tu información esté protegida contra accesos no autorizados.
      </p>

      <h3>4. Tus derechos</h3>
      <p>
        Tienes derecho a acceder, corregir o solicitar la eliminación de tus datos personales de nuestras bases en cualquier momento. Para ejercer este derecho, puedes escribirnos a <strong>disenosdanyweb@gmail.com</strong>.
      </p>
    </PageContainer>
  );
};

export default PoliticaPrivacidad;